module.exports = __webpack_public_path__ + "img/banners-vaccine.d55a9fa7.jpg";